import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const UpdateRateForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        name: '',
        min_reading: 0,
        min_price: 0,
        public_id: '',
    })
    const {name, min_reading, min_price, public_id} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (location.state){
            const {rate} = location.state
            setFormData({
                public_id: rate.public_id,
                name: rate.name,
                min_reading: Number.parseInt(rate.min_reading),
                min_price: Number.parseInt(rate.min_price),
            })
        }

    }, [location])

    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const rateData = {name, min_reading, min_price}
        updateRate(public_id, rateData)
    }

    //update rate
    const updateRate = async (public_id, rateData) => {
        try {
            setIsLoading(true)
            const response = await Server.put(`/rates/${public_id}`, rateData)
            if(response.status === 200){
                toast.success('Successfully updated')
                navigate('/rates')
                setIsLoading(false)
            }else{
                setIsLoading(false)
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update Rate Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Rate Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Minimum Reading"
                                name="min_reading"
                                type="number"
                                label="MinReading"
                                value={min_reading}
                                onChange={onChange}
                                error={errors.min_reading}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Minimum Price"
                                name="min_price"
                                type="number"
                                required="required"
                                label="MinPrice"
                                value={min_price}
                                onChange={onChange}
                                error={errors.min_price}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-info" value="Update Rate" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default UpdateRateForm
